// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3jBWw","footer":"ModalInfo_footer__2TkYC"};